"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _aphrodite = require("aphrodite");

var _Markdown = _interopRequireDefault(require("./text/Markdown"));

var _styling = require("../toolkit/styling");

var _providers = require("../toolkit/providers");

//
//  LightBanner.tsx
//  Project-Lego
//
//  Created by Chiyi Wang on 12/30/19.
//  Copyright © 2019-present ContextLogic Inc. All rights reserved.
//

/* eslint-disable filenames/match-regex */

/* Lego Components */

/* Lego Toolkit */
var propDoc = {
  text: {
    required: true,
    type: "string",
    description: "Text content"
  },
  sentiment: {
    required: false,
    type: "WishBlue",
    description: "Sentiment of the banner - determines the color treatment"
  },
  padding: {
    required: false,
    type: "string",
    description: "Amount of padding to apply"
  }
};
var demoProps = {
  text: "Demo text"
};

var LightBanner = function LightBanner(props) {
  var styles = useStylesheet(props);
  var text = props.text,
      childrenProp = props.children,
      className = props.className;

  var children = _react["default"].Children.toArray(childrenProp).filter(function (e) {
    return /*#__PURE__*/_react["default"].isValidElement(e) || typeof e == "string";
  });

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _styling.css)(styles.root, className)
  }, /*#__PURE__*/_react["default"].createElement(_Markdown["default"], {
    className: (0, _styling.css)(styles.text),
    text: text
  }), children);
};

LightBanner.propDoc = propDoc;
LightBanner.demoProps = demoProps;
var _default = LightBanner;
exports["default"] = _default;

var useStylesheet = function useStylesheet(props) {
  var _useTheming = (0, _providers.useTheming)(),
      fonts = _useTheming.fonts,
      _useTheming$theme = _useTheming.theme,
      corePrimaryLightest = _useTheming$theme.corePrimaryLightest,
      corePrimaryDarkest = _useTheming$theme.corePrimaryDarkest,
      primaryLight = _useTheming$theme.primaryLight,
      primaryDark = _useTheming$theme.primaryDark;

  var textColor = (0, _react.useCallback)(function (props) {
    switch (props.sentiment) {
      case "WishBlue":
        return corePrimaryDarkest;

      default:
        return corePrimaryDarkest;
    }
  }, [corePrimaryDarkest]);
  var backgroundColor = (0, _react.useCallback)(function (props) {
    switch (props.sentiment) {
      case "WishBlue":
        return corePrimaryLightest;

      default:
        return corePrimaryLightest;
    }
  }, [corePrimaryLightest]);
  return (0, _react.useMemo)(function () {
    return _aphrodite.StyleSheet.create({
      root: {
        borderRadius: 4,
        backgroundColor: backgroundColor(props) || primaryLight,
        display: "flex",
        flexDirection: "row",
        padding: props.padding || "20px 24px",
        fontFamily: fonts.regular
      },
      text: {
        color: textColor(props) || primaryDark
      }
    });
  }, [props, primaryLight, fonts.regular, primaryDark, backgroundColor, textColor]);
};